import { Member } from 'types/membership';

export function isOwner(member: Member): boolean {
  if (!member.roles) {
    return false;
  }
  return hasOwnerRole(member.roles);
}

export function hasOwnerRole(roles: readonly string[]): boolean {
  return roles.findIndex((role) => role === 'OWNER') > -1;
}
